import { useNavigate } from '@tanstack/react-router';

import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { IconPlus } from '../../icons/cdl/Plus';
import { useFlags } from '../../launchDarkly/useFlags';
import { Box } from '../../ui/Box';
import { SidebarNavigationItem } from '../components/SidebarNavigationItem';

export const CustomerSidebarNavigation = () => {
    const role = useRole();
    const navigate = useNavigate();
    const flags = useFlags();

    return (
        <Box display="grid" gap={16}>
            {role.hasAnyCompanyWriteRights() ? (
                <Box width="100%" paddingX={8}>
                    <Button
                        width="100%"
                        onClick={() => {
                            navigate({ to: '/orders/new' });
                        }}
                        emphasis="high"
                        LeadingIcon={IconPlus}
                    >
                        {translate('navigation.createnew')}
                    </Button>
                </Box>
            ) : null}

            <Box display="flex" flexDirection="column">
                <SidebarNavigationItem to="/dashboard">{translate('navigation.dashboard')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/orders">{translate('navigation.orders')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/demand">{translate('navigation.demandOverview')}</SidebarNavigationItem>

                {flags.demandDefinitionsEnabled && role.hasAnyAdminRights() ? (
                    <SidebarNavigationItem to="/demand-definitions">
                        {translate('navigation.demandDefinitions')}
                    </SidebarNavigationItem>
                ) : null}

                <SidebarNavigationItem to="/compare">{translate('navigation.compare')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/vessels">{translate('navigation.vessels')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/key-ports">{translate('navigation.keyPorts')}</SidebarNavigationItem>

                {role.hasAnyAdminRights() ? (
                    <SidebarNavigationItem to="/contracts">{translate('navigation.contracts')}</SidebarNavigationItem>
                ) : null}

                {role.hasAnyAdminRights() ? (
                    <SidebarNavigationItem to="/agents">{translate('navigation.agents')}</SidebarNavigationItem>
                ) : null}

                <SidebarNavigationItem to="/statistics">{translate('navigation.reporting')}</SidebarNavigationItem>
            </Box>
        </Box>
    );
};
